import { Actions, Action } from '../../redux/Actions';
import { BuildingCollection, Building } from '../../Building'
import { Configuration } from '../../Configuration';
import { CssElement } from '../../css_utils';
import { Dispatcher, dispatch_action } from '../../redux/Dispatcher';
import { Drawing } from '../../drawings/Drawing'
import { DrawingsCollection } from '../../drawings/DrawingsCollection'
import { Id_building, Id_floor, Id_drawing } from '../../api/Identifiers'
import { Keys } from '../../redux/Datastore'
import { State, did_any_change, get_state } from '../../redux/State'

class UI {
    public static get menu_row_count(): number {
        const ul = UI.menu_buildings_content_list_ul;
        return ul ? ul.children.length : 0;
    }

    public static append_menu_row(li: HTMLLIElement): void {
        if (li) {
            UI.menu_buildings_content_list_ul.appendChild(li);
        }
    }

    public static li_from_html(html: string): HTMLLIElement {
        return <HTMLLIElement>$.parseHTML(html.trim())[0];
    }

    public static get menu_buildings_header_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById('menu_buildings_header');
    }

    public static get menu_buildings_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById('menu_buildings');
    }

    public static get menu_buildings_content_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById('menu_buildings_content');
    }

    public static get menu_buildings_content_list_ul(): HTMLUListElement {
        return <HTMLUListElement>document.getElementById('menu_buildings_content_list');
    }

    public static set expanded(is_expanded: boolean) {
        const chevron = document.getElementById("menu_buildings_header_chevron");
        if (!chevron) {
            return;
        }
        if (is_expanded) {
            chevron.classList.remove("glyphicon-chevron-right")
            chevron.classList.add("glyphicon-chevron-down")
        } else {
            chevron.classList.remove("glyphicon-chevron-down")
            chevron.classList.add("glyphicon-chevron-right")
        }
        const content = UI.menu_buildings_content_div;
        if (content) {
            CssElement.wrap(content).visibility = is_expanded;
        }
    }
    public static set visible(is_visible: boolean) {
        const menu = this.menu_buildings_div;
        if (!menu) {
            return;
        }
        if (is_visible) {
            CssElement.wrap(menu).show();
        } else {
            CssElement.wrap(menu).hide();
        }
    }
}

export function force_draw_buildings_menu() {


    let state: State | undefined = undefined;
    try {
        state = get_state();
    } catch (e) {
        console.error('force_draw_buildings_menu: get_state() failed', e);
        return;
    }
    if (!state || !state.buildings || !state.buildings.buildings) {
        console.warn('force_draw_buildings_menu: invalid state');
        return;
    }

    if (!UI.menu_buildings_content_list_ul) {
        return;
    }

    UI.menu_buildings_content_list_ul.innerHTML = "";  // clear the menu
    UI.visible = state.menu_buildings_show;

    state.buildings.buildings.forEach((building: Building) => {
        let id_building: Id_building = building.id_building;
        if (state.all_displayable_drawings.get_all_in_building(id_building).length > 0) {
            let menu_item_id: string = `menu_buildings_item_${id_building.value}`;
            let badge: string = "";
            let wo_count: number = state.building_wo_count[id_building.value];
            if (Configuration.building_workorder_count_feature_enabled) {
                if (wo_count > 0) {
                    badge = wo_count.toString();
                }
            }
            let html: string = `
            <li style='padding: 2px' class='list-group-item' id_building='${id_building.value}'>
            <a href='#' id='${menu_item_id}' class='waves-effect' id_building='${id_building.value}'>${building.label}</a>
            <span class='badge'>${badge}</span>
            </li>`;

            let li: HTMLLIElement = UI.li_from_html(html);
            UI.append_menu_row(li);
            let anchor = document.getElementById(menu_item_id);
            if (anchor) {
                anchor.onclick = onclick_menu_item_selected;
            }
        }
    });

    const ul = UI.menu_buildings_content_list_ul;
    const selected_building = state.id_building ? String(state.id_building.value) : null;
    if (ul && selected_building) {
        for (let i = 0; i < ul.children.length; i++) {
            const li = ul.children[i] as HTMLLIElement;
            const li_building = li.getAttribute('id_building');
            if (li_building === selected_building) {
                li.classList.add('selected');
            } else {
                li.classList.remove('selected');
            }
        }
    }
}

export function draw_buildings_menu() {
    if (!Configuration.buildings_feature_enabled) {
        return;
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN])) {
        if (UI.menu_buildings_header_div) {
            UI.menu_buildings_header_div.onclick = onclick_expand;
        }
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN, Keys.MENU_BUILDINGS_EXPANDED])) {
        UI.expanded = get_state().menu_buildings_expanded;
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN, 
        Keys.ID_BUILDING,
        Keys.HASH_BUILDINGS_DATA,
        Keys.HASH_DATA_FLOORPLANS,
        Keys.HASH_DRAWINGS_INFO_DATA,
        Keys.MENU_BUILDINGS_SHOW,
        Keys.KEY_BUILDING_WO_COUNT])) {

        force_draw_buildings_menu()
    }
}

function onclick_expand() {
    dispatch_action(Action.set_key_boolean(Keys.MENU_BUILDINGS_EXPANDED, !get_state().menu_buildings_expanded));
}

function onclick_menu_item_selected(this: HTMLElement, ev: MouseEvent): any {
    ev.preventDefault();
    let id_location: Id_building = Id_building.wrap(this.getAttribute("id_building"));
    Dispatcher.dispatch(Actions.ACTION_SET_ID_BUILDING, id_location.value);
}


// WEBPACK FOOTER //
// ./src/ts/ui/menu/BuildingsMenu.ts